"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CODEC = exports.validCodecs = void 0;
exports.validCodecs = [
    'h264',
    'h265',
    'vp8',
    'vp9',
    'mp3',
    'aac',
    'wav',
    'prores',
    'h264-mkv',
    'gif',
];
exports.DEFAULT_CODEC = 'h264';
